// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1TpPe","label":"Section_label__23Abs","contentWrap":"Section_contentWrap__8csYF","footer":"Section_footer__2cg7B","footerInner":"Section_footerInner__3v11q"};